import LandingPageJumbotron from '@/app/components/LandingPage/LandingPageJumbotron';

const SleepAndRestBlurb = () => {
  return (
    <section data-cy="sleep-and-rest-blurb">
      <LandingPageJumbotron
        description="sleep_and_rest_headline_description"
        inverted
        title="sleep_and_rest_headline_title"
      />
    </section>
  );
};

export default SleepAndRestBlurb;
